import { SipNumberBulkStatusUpdateRequest } from "../../model/sipNumberBulkStatusUpdateRequest";
import { fetchPutJSON } from "../api-helpers";
import { apiUrls } from "../constants";

type DtoType = SipNumberBulkStatusUpdateRequest;

export async function putSipNumbersBulkStatusUpdate(payload: DtoType) {
  try {
    const url = apiUrls.postSipNumbersBulkStatusUpdate;
    return await fetchPutJSON(url, payload);
  } catch (err) {
    console.error("API Error - putSipNumbersBulkStatusUpdate:", err);
  }
}
